'use client'

import React from 'react'
import { LuArrowUpLeft, LuArrowUpRight } from 'react-icons/lu'
import { useLocale } from '../LocaleContext'

export type BrowseProductsButtonProps = {
  href?: string
  children?: React.ReactNode
  className?: string
}

// const defaultLabel = (
//   <div className="flex flex-row items-center justify-start gap-2.5 pl-[10px] pr-[160px] max-[480px]:pr-8 max-[400px]:pr-4 max-[400px]:pt-4 pt-[30px] text-left text-[25px] max-[400px]:text-xl font-semibold leading-[26px] uppercase">
//     <div className="flex pl-[20px] flex-col items-start">
//       <span className="block whitespace-nowrap">Browse</span>
//       <span className="block whitespace-nowrap">Products</span>
//     </div>
//     <LuArrowUpRight
//       size={18}
//       aria-hidden
//       className="shrink-0 translate-x-[35px] translate-y-[10px]"
//     />
//   </div>
// )

export function BrowseProductsButton({
  href = '#',
  children,
  className = '',
}: BrowseProductsButtonProps) {
  const { locale, translatedData } = useLocale()
  const label = translatedData?.common.browse_products ?? 'Browse Products'
  const [firstWord, ...restWords] = label.split(' ')
  const secondLine = restWords.join(' ')

  const resolvedChildren = children ?? (
    <div dir={locale == 'ar' ? 'rtl' : 'ltr'} className="flex flex-row items-center justify-start gap-2.5 pl-2.5 pr-12 max-[400px]:pt-4 pt-[30px] text-[25px] max-[400px]:text-xs font-light leading-[26px] uppercase rtl:justify-end rtl:pr-2.5 rtl:pl-10">
      <div className="flex pl-5 rtl:pr-5 rtl:pl-[unset] flex-col items-start rtl:items-end rtl:w-full ml-3">
        <span className="whitespace-nowrap rtl:text-right">{firstWord}</span>
        <span className="whitespace-nowrap rtl:text-right">{secondLine}</span>
      </div>
      {locale === 'ar' ? (
        <LuArrowUpLeft
          size={18}
          aria-hidden
          className="shrink-0"
        />
      ) : (
        <LuArrowUpRight
          size={18}
          aria-hidden
          className="shrink-0 translate-x-[35px] translate-y-[10px]"
        />
      )}
    </div>
  )

  return (
    <a
      href={href}
      className={`gallium-search-action__btn gallium-search-action__btn--outline browse-products-btn ${className}`.trim()}
    >
      {resolvedChildren}
    </a>
  )
}
